import Button from "../../components/Button";
import Logo from "../../components/Logo";
import Redirect from "../../components/Redirect";
import { useAuth } from "../../hooks/useAuth";

export default function DownloadApp() {
  const { logout } = useAuth();

  if (localStorage.getItem("continueToWebApp") === "true") {
    return <Redirect to="/" />;
  }

  return (
    <div className="flex flex-col items-center justify-between h-screen p-4">
      <div className="flex flex-col items-center justify-center flex-1">
        <Logo className="text-2xl" />
      </div>

      <div className="flex flex-col items-center justify-center flex-1 text-center">
        <h1 className="text-xl font-bold">Téléchargez l'application</h1>
        <p className="text-sm text-secondary">
          Téléchargez l'application pour continuer à utiliser Kontrol.
        </p>
      </div>

      <div className="flex flex-col items-center justify-end flex-1 w-full">
        <Button
          variant="primary"
          className="w-fit h-12 mt-8"
          onClick={() =>
            window.open(
              "https://apps.apple.com/fr/app/kontrol/id6742754633",
              "_blank",
              "noopener,noreferrer"
            )
          }
        >
          Télécharger l'application
        </Button>
        <Button
          variant="secondary"
          className="w-full h-12 mt-8"
          onClick={() => logout()}
        >
          Se déconnecter
        </Button>
        <Button
          variant="secondary"
          className="w-full h-12 mt-8"
          onClick={() => {
            localStorage.setItem("continueToWebApp", "true");
            window.location.reload();
          }}
        >
          Je veux quand même rester sur le web
        </Button>
      </div>
    </div>
  );
}
